import { http } from './http';

export async function getCounterparties(params) {
    return http.get('wms/counterparties/', { params });
}

export async function createCounterparty(data) {
    return http.post('wms/counterparties/', data);
}

export async function updateCounterparty(id, data) {
    return http.patch(`wms/counterparties/${id}/`, data);
}

export async function deleteCounterparty(id) {
    return http.delete(`wms/counterparties/${id}/`);
}
